import React from "react";
import { s360ConfigService } from "../Services/S360Config";

const OfflineMessage = () => {
  const businessHour = s360ConfigService?.config?.businessHour;
  const offlineConfig = businessHour?.offlineHour;
  const title = offlineConfig?.title || "We’re currently offline";
  // Prefer top-level businessHour.offlineMessage when present, else fallbacks
  const message =
    (businessHour?.offlineMessage || "").trim() ||
    (offlineConfig?.message || "").trim() ||
    "Our team is unavailable right now. Please check back during business hours.";

  return (
    <div className="s360-initial-form-container" style={{ padding: 16 }}>
      <div className="s360-initial-form">
        <h3 style={{ marginBottom: 8 }}>{title}</h3>
        <p style={{ margin: 0 }}>{message}</p>
      </div>
    </div>
  );
};

export default OfflineMessage;
